// extracted by mini-css-extract-plugin
export default {"note":"styles_note__RcVo8","subNote":"styles_subNote__6Hay5"};